<template>
  <div class="task-daygrid-event">
    <div class="fc-event-main-frame">
      <div class="task-daygrid-icon-container">
        <Icon iconStyle="far" :icon="taskStatusIcon(task.status)" />
      </div>
      <div class="fc-event-title-container">
        <div class="fc-event-title fc-sticky">{{title}}</div>
      </div>
      <div class="fc-event-time">
        {{timeText}}
      </div>
    </div>
    <div class="task-daygrid-event-labels" v-if="hasLabels">
      <LabelTags :labelList="task.labels" />
    </div>
  </div>
</template>

<script>
import TaskManagerMixin from '@/modules/tasks/mixins/taskManagerMixin'
import { TaskStatusTypes } from '@/store/types'

export default {
  name: 'CalendarDayGridTaskView',
  mixins: [TaskManagerMixin],
  props: {
    title: String,
    timeText: String,
    task: Object
  },
  computed: {
    isTaskStatusCancelled() {
      if(!this.task)
        return false
      return this.task.status == TaskStatusTypes.cancelled
    },
    isTaskStatusCompleted() {
      if(!this.task)
        return false
      return this.task.status == TaskStatusTypes.completed
    },
    hasLabels() {
      return this.task && this.task.labels && this.task.labels.length > 0
    }
  },
  mounted() {
  }
}
</script>